<template>
  <v-container>
    <template v-if="user.loggedIn" class="alert alert-success" role="alert">
      <h2>
        Handles
      </h2>
     <v-form ref="form" @submit.prevent="submit" v-model="valid">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="handle"
              :rules="handleRules"
              :counter="10"
              label="Handle"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
          <v-btn type="submit" color="info">Add</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form> 
    <v-card
        class="mx-auto pa-3 ma-2 text-center"
        max-width="400"
        v-for="handle in handles"
        :key="handle.id"
      >
        <v-row>
          <v-col cols="8">
            <v-list-item-title class="headline mb-2">{{ handle.name }}</v-list-item-title>
          </v-col>
          <v-col cols="2">
            <v-dialog ref="sendmsg" v-model="dialog" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                <v-icon left>mdi-cellphone-message</v-icon> 
                  Send Message
                </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Message to all subscribers</span>
              </v-card-title>
                <v-text-field
                  v-model="message"
                  :rules="messageRules"
                  :counter="100"
                  label="Message"
                  required
                ></v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="sendit(handle, message)">Send</v-btn>
              </v-card-actions>
            </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card>
    <v-snackbar v-model="snackbar">
			{{ snackmsg }}
			<v-btn
				color="pink"
				text
				@click="snackbar = false"
			>
				Close
			</v-btn>
      </v-snackbar>
    </template>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  props: ['id'],
  data: () => ({
    valid: false,
    dialog: false,
    snackmsg: '',
    snackbar: false,
    handle: '',
    handles: [],
    handleRules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
      value => (value && value.length < 10) || 'Max 10 characters'
    ],
    message: '',
    messageRules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
      value => (value && value.length < 100) || 'Max 100 characters'
    ]
  }),
    watch: {
      user: {
        handler: function(newVal) {
          // need user.id so I can filter by id...
          if (!newVal.loggedIn) { return } 
          this.$bind('handles', firebase.firestore().collection('handles')
            .orderBy("name")
            .where("owner", "==", newVal.data.uid))
        },
        deep: true,
        immediate: true,
      },
  },
  
  methods: {
    deleteHandle(id) { // XXX should ask for verification
      firebase.firestore().collection("handles")
        .doc(id)
        .delete();
      this.$refs.form.reset()
    },
    sendit(h,m) {
      // write the mesg to outbox collection
      console.log(h)
      if (!m) { return }
      if (m.length < 3 || m.length > 100) { return }

      firebase.firestore().collection("outbox").add({
        owner: h.owner,
        handle: h.id,
        message: m
      })
      this.dialog = false
      this.message = ''
    },
    gotoHandle(name) {
      // goto a url dashboard/name
      console.log(name)
      // Maybe 
    },
    submit() { 
      // The view model
      // this.$refs.form.reset()
      if (!this.$refs.form.validate()) { return }
      var vm = this
      var user = this.user
      this.$db.collection("handles").where("name", "==", this.handle)
        .get()
        .then(function(querySnapshot) { 
          switch (querySnapshot.size) {
            case 0: 
              // XXX check user's account balance 
              vm.snackmsg = vm.handle + " is available, $1 for you!"
              vm.snackbar = true
              // add the handle
              vm.$db.collection('handles').doc(vm.handle.toLowerCase()).set({
                name: vm.handle,
                owner: user.data.uid
              })
              // XXX deduct $1 from user's account
              vm.$refs.form.reset()
              break
            case 1:
              // handle exists, show error
              vm.snackmsg = "Sorry, handle already in use, try another."
              vm.snackbar = true
              break
            default:
              vm.snackmsg = "System error, more than one handle, try another."
              vm.snackbar = true
              console.log("dashboard: Error, more than one handle ", vm.handle)
          }
          if (querySnapshot.size > 0) {
            console.log("multiple handles")
          }
        })
        .catch(function(error) {
          vm.snackmsg = "Error reading connected to the db: " + error
          vm.snackbar = true
          console.log("Error getting document:", error);
        })

      // this.$refs.form.reset() should wait until add is done
    }
  },
  computed: {
    // map `vm.user` to `vm.$store.getters.user`
    ...mapGetters({
      user: "user"
    })
  }
}
</script>
